export default {
  en: {
    noJobsRunning: 'No running or scheduled jobs ',
    jobsQueueTitle: 'Jobs Queue',
    scheduledTitle: 'Scheduled Jobs',
    jobsResultsTitle: 'Jobs Results',
    name: 'Name:',
    jobs: {
      aimImport: 'Application Infrastructure Mapping Import',
      aimFlowPathLookup: 'Calculating application flow devices',
      backup: 'System backup',
      cleanDb: 'Clean DB',
      collectDeviceConfigurations: 'Collect device configurations',
      deleteDevice: 'Deleting devices',
      discovery: 'Network discovery',
      maintenance: 'Maintenance',
      recalculateSites: 'Rebuilding network topology',
      report: 'Calculating reports',
      saveHistoricalData: 'Calculating data for changes',
      snapshotArchive: 'Snapshot archive',
      snapshotClone: 'Cloning snapshot',
      snapshotDelete: 'Deleting snapshot',
      snapshotDownload: 'Snapshot download',
      snapshotLoad: 'Loading snapshot',
      snapshotsRetention: 'Snapshots Retention',
      snapshotUnload: 'Unloading snapshot',
      snapshotVerify: 'Verifying snapshot',
      techsupport: 'Generating techsupport',
      topologyCalculation: 'Calculating network topology',
      updatePathLookupChecksResults:
        'Calculating result for path lookup check ',
      calculateLabels: 'Calculating labels',
      loadGraphCache: 'Load graph cache',
      error: {
        snapshotArchive: 'Invalid snapshot archive',
      },
      configurationExport: 'Configuration Export',
      configurationImport: 'Configuration Import',
      toggleMcp: 'MCP Server status changed',
    },
    toggleMcpEnabled: 'Server is running',
    toggleMcpDisabled: 'Server is stopped',
    cancelTooltip: 'Cancel',
    clearTooltip: 'Clear',
    errorReason: 'Error: {reason}',
    errorTooltip: 'Error',
    runningTooltip: 'Running',
    scheduledTooltip: 'Scheduled',
    stoppingTooltip: 'Stopping',
    stopTooltip: 'Cancel',
    stopDialogue: {
      title: 'The process will be ended',
      readTitle: 'File has not been downloaded yet',
      subHeader: 'Do you really want to end process?',
      readSubHeader:
        'Do you really want to clear it? The download link will be lost.',
      btnCancel: 'Cancel',
      btnConfirm: 'End process',
      btnClearConfirm: 'Clear',
    },
    btnClearAll: 'Clear all',
    download: 'Download',
    viewDevices: 'View devices',
    request: {
      snapshotDownloadReady: 'Snapshot download ready',
      techsupportReady: 'Techsupport ready',
      loadGraphCache: 'Load graph cache started',
      configurationExportReady: 'Configuration export ready',
      configurationImported: 'Configuration has been imported',
      aimFlowPathLookupDone: 'Application flow devices calculated',
    },
  },
};
